@if (compare.count() > 0) {
  <aside class="compare-bar" role="region" [attr.aria-label]="'compare.barLabel' | translate">
    <div class="compare-bar-inner wrap">
      <div class="compare-bar-meta">
        <span class="compare-bar-count">
          {{ 'compare.selectedCount' | translate: { count: compare.count(), max: compare.max } }}
        </span>
        <button type="button" class="compare-bar-clear" (click)="clear()">
          {{ 'compare.clear' | translate }}
        </button>
      </div>

      <ul class="compare-bar-list">
        @for (item of compare.items(); track item.id) {
          <li class="compare-bar-item">
            <a [routerLink]="['/product', item.slug + '-' + item.id]" class="compare-bar-link">
              @if (item.imageUrl) {
                <img [src]="item.imageUrl" [alt]="item.name" width="48" height="48" />
              } @else {
                <span class="compare-bar-ph material-symbols-outlined">inventory_2</span>
              }
              <span class="compare-bar-name">{{ item.name }}</span>
            </a>
            <button
              type="button"
              class="compare-bar-remove"
              (click)="remove(item.id, $event)"
              [attr.aria-label]="'compare.remove' | translate"
            >
              <span class="material-symbols-outlined">close</span>
            </button>
          </li>
        }
      </ul>

      <button
        type="button"
        class="btn btn-primary compare-bar-cta"
        (click)="goCompare()"
        [disabled]="compare.count() < 2"
      >
        {{ 'compare.compareNow' | translate }}
      </button>
    </div>
  </aside>
}
